/** @format */

import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TAPILicenseListSuccess } from "../../redux-modules/declarations/apis/licenses";
import apiClient from "../../utils/apiClient";

export const apiLicenseList = (): Promise<AxiosResponse<TAPILicenseListSuccess>> =>
  apiClient.get(API_ENDPOINTS.LICENSE);
